import { Weekday } from 'rrule';

export const germanStrings: { [key: string]: string } = {
  every: 'alle',
  everySINGLE: 'jede/jeden',
  until: 'bis',
  day: 'Tag',
  days: 'Tage',
  week: 'Woche',
  weeks: 'Wochen',
  on: 'am',
  in: 'in',
  'on the': 'am',
  for: 'für',
  and: 'und',
  or: 'oder',
  at: 'bei',
  last: 'zuletzt',
  '(~ approximate)': '(~ approximativ)',
  times: 'Zeiten',
  time: 'Zeit',
  minutes: 'Minuten',
  hours: 'Stunden',
  weekdays: 'Wochentage',
  weekday: 'Wochentag',
  months: 'Monate',
  month: 'Monat',
  years: 'Jahre',
  year: 'Jahr',
  th: '.',
};

export const RRULE_GERMAN = {
  dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
  monthNames: [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
  ],
  tokens: {},
};

export const getText = (id: string | number | Weekday, interval: number, locale: string) => {
  if (typeof id !== 'string') {
    return '';
  }
  if (locale === 'en_US') {
    return id;
  }

  if (id === 'every' && interval === 1) {
    return germanStrings.everySINGLE;
  }
  return germanStrings[id] || id;
};
